import { getAuthToken } from "./authToken";

export async function downloadFile(book, format = "pdf") {
  if (!book || !book.id) {
    alert("No book details found.");
    return;
  }

  const path = format === "epub" ? book.epubPath : book.pdfPath;
  if (!path) {
    alert(`No ${format.toUpperCase()} version available for this book yet.`);
    return;
  }

  // Auth token required — download endpoint is protected
  const token = await getAuthToken();
  if (!token) {
    alert("Please sign in to download books.");
    return;
  }

  try {
    // Fetch with auth header, then trigger browser download from blob
    const res = await fetch(`/api/download?id=${book.id}&format=${format}`, {
      headers: { Authorization: `Bearer ${token}` },
      redirect: "follow",
    });

    if (res.status === 401) {
      alert("Please sign in to download books.");
      return;
    }
    if (!res.ok) {
      const data = await res.json().catch(() => ({}));
      alert(data.error || "Download failed. Please try again.");
      return;
    }

    const blob = await res.blob();
    const blobUrl = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = `${book.title || "book"}.${format}`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setTimeout(() => URL.revokeObjectURL(blobUrl), 10000);
  } catch (err) {
    console.error("[download] error:", err);
    alert("Download failed. Please check your connection and try again.");
  }
}

// Keep downloadPDF for backward compatibility
export async function downloadPDF(book) {
  return downloadFile(book, "pdf");
}
